import { render, staticRenderFns } from "./unsatisfactory-list-search-form.vue?vue&type=template&id=2871bab6"
import script from "./unsatisfactory-list-search-form.vue?vue&type=script&lang=js"
export * from "./unsatisfactory-list-search-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports